import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../assets/1.jpeg";
import img2 from "../assets/2.jpeg";
import img3 from "../assets/3.jpeg";
import img4 from "../assets/4.jpeg";
import img5 from "../assets/5.jpeg";
import img6 from "../assets/6.jpeg";
import img7 from "../assets/7.jpg";
import img8 from "../assets/8.jpg";
import img9 from "../assets/9.jpg";
import img10 from "../assets/10.jpg";
import img11 from "../assets/11.JPG";

const SlickCarouselWithGlobalHeading = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show 3 slides at a time
    slidesToScroll: 1, // Scroll 1 slide at a time
    arrows: true,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Time interval between slides (in milliseconds)
    responsive: [
      {
        breakpoint: 1024, // For tablets and smaller screens
        settings: {
          slidesToShow: 2, // Show 2 slides at a time
        },
      },
      {
        breakpoint: 640, // For mobile screens
        settings: {
          slidesToShow: 1, // Show 1 slide at a time
        },
      },
    ],
  };

  const slides = [
    {
       image: img1 ,
    },
    {
      image: img2 ,
    },
    {
      image: img3 ,
    },
    {
      image: img4 ,
    },
    {
      image: img5 
    },
    {
      image: img6 ,
    },
    {
      image: img7 ,
    },
    {
      image: img8 ,
    },
    {
      image: img9 ,
    },
    {
      image: img10 ,
    },
    {
      image: img11 ,
    },
  ];

  return (
    <div className="container mx-auto py-8 px-4">
      {/* Global Heading */}
      <div className="text-left mb-8">
        <h2 className="text-2xl font-semibold text-[#07294D] mb-4 ml-2">
          Featured Images
        </h2>
      </div>

      {/* Slick Carousel */}
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="px-2">
            <div
              className="w-full h-64 md:h-80 bg-cover bg-center rounded-lg shadow-lg"
              style={{ backgroundImage: `url(${slide.image})` }}
            ></div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SlickCarouselWithGlobalHeading;
